import { createFileRoute, Navigate } from "@tanstack/react-router"
import { CampaignKnowledgeBase } from "modules/campaigns/components/Detail/KnowledgeBase"
import { useCampaignQuery } from "modules/campaigns/hooks/useCampaignQuery"

export const Route = createFileRoute("/_base/_auth/campaigns/$id/knowledge-base")({
  component: Component,
})

function Component() {
  const { id } = Route.useParams()
  const { data: campaign } = useCampaignQuery(id)

  if (campaign?.isLogistics) {
    return <Navigate to="/campaigns/$id/insights" params={{ id }} replace />
  }

  return <CampaignKnowledgeBase id={id} />
}
